import { GetAccounts, GetAccountTypeMaps } from "../services/financialService";
const requestAccountsType = "REQUEST_ACCOUNTS";
const receiveAccountsType = "RECEIVE_ACCOUNTS";
const requestAccountTypeMapsType = "REQUEST_ACCOUNT_TYPE_MAPS";
const receiveAccountTypeMapsType = "RECEIVE_ACCOUNT_TYPE_MAPS";
const initialState = {
  accounts: [],
  accountTypeMaps: [],
  loading: false,
  loadingAccountTypeMaps: false
};

export const actionCreators = {
  requestAccounts: () => async (dispatch, getState) => {
    let { accounts } = getState().accounts;
    if (accounts && accounts.length > 0) {
      return;
    }
    dispatch({ type: requestAccountsType });

    accounts = await GetAccounts();

    dispatch({ type: receiveAccountsType, accounts });
  },
  requestAccountTypeMaps: () => async (dispatch, getState) => {
    let { accountTypeMaps } = getState().accounts;
    if (accountTypeMaps && accountTypeMaps.length > 0) {
      return;
    }
    dispatch({ type: requestAccountTypeMapsType });

    accountTypeMaps = await GetAccountTypeMaps();

    dispatch({ type: receiveAccountTypeMapsType, accountTypeMaps });
  }
};

export const reducer = (state, action) => {
  state = state || initialState;

  if (action.type === requestAccountsType) {
    return {
      ...state,
      loading: true
    };
  }

  if (action.type === receiveAccountsType) {
    const { accounts } = action;
    return {
      ...state,
      accounts,
      loading: false
    };
  }

  if (action.type === requestAccountTypeMapsType) {
    return {
      ...state,
      loadingAccountTypeMaps: true
    };
  }

  if (action.type === receiveAccountTypeMapsType) {
    const { accountTypeMaps } = action;
    return {
      ...state,
      accountTypeMaps,
      loadingAccountTypeMaps: false
    };
  }

  return state;
};
